import { getLookbackListApi } from '@api/project'

/** 列表接口分页字段 */
export const LOOKBACK_LIST_FIELDS = Object.freeze({
  total: 'total_count',
  list: 'data',
  from: 'offset',
  size: 'limit'
})

export const LOOKBACK_DEFAULT_PAGE = Object.freeze({ from: 1, size: 10 })

const AUTH_STATUS_OPTIONS = {
  0: {
    label: "未审核",
    color: "#898989",
  },

  1: {
    label: "已审核",
    color: "rgb(103, 194, 58)",
  }
}
const TABLE_COLUMNS_BASE = [
  {
    key: 'selection',
    title: ' ',
    type: 'selection',
    width: 48,
    align: 'center',
    /** 仅未审核行可勾选，与行内审核/退回一致 */
    selectable: row => !!(row && !row.auditStatus)
  },
  {
    title: '支部名称',
    key: 'name',
    tooltip: true,
    minWidth: 200,
    align: 'center'
  },
  {
    title: '提交时间',
    key: 'createTime',
    width: 170,
    align: 'center'
  },
  {
    title: '基础得分',
    key: 'baseScore',
    width: 100,
    align: 'center'
  },
  {
    title: '加分',
    key: 'addScore',
    width: 80,
    align: 'center'
  },
  {
    title: '总分',
    key: 'totalScore',
    width: 80,
    align: 'center'
  },
  {
    title: '标识',
    key: 'mark',
    width: 100,
    align: 'center'
  },
  {
    title: '状态',
    slot: 'rowStatus',
    width: 110,
    align: 'center'
  },
  {
    title: '操作',
    slot: 'operation',
    width: 200,
    fixed: 'right',
    align: 'center'
  }
]

const TABLE_COLUMNS = Object.freeze(TABLE_COLUMNS_BASE)

const EMPTY_TAB_EXTRA = Object.freeze({})

export const LOOKBACK_TABLE_DEF = Object.freeze({
  province: {
    tableRequest: getLookbackListApi,
    fields: LOOKBACK_LIST_FIELDS,
    columns: TABLE_COLUMNS,
    extraTableParams: EMPTY_TAB_EXTRA
  }
})

export const LOOKBACK_STATUS_FILTER = Object.freeze([
  { label: '未审核', value: 0 },
  { label: '已审核', value: 1 }
])

/** 示范支部回头看首页 Tab */
export const LOOKBACK_INDEX_TABS_PROVINCE = Object.freeze([
  { label: '回头看情况表', name: 'province' }
])

function normalizeLookbackRow(raw) {
  const row = raw || {}
  const uid = row.id

  const auditVal = row.auditStatus ?? 0
  const authStatusLabel = AUTH_STATUS_OPTIONS[auditVal]?.label ?? AUTH_STATUS_OPTIONS[0].label
  const authStatusColor = AUTH_STATUS_OPTIONS[auditVal]?.color ?? AUTH_STATUS_OPTIONS[0].color

  return {
    ...row,
    uid,
    authStatusLabel,
    authStatusColor
  }
}

export function transformLookbackListResult(result) {
  if (!result) return []
  const list = result.data != null ? result.data : result.list
  const arr = Array.isArray(list) ? list : []
  return arr.map(normalizeLookbackRow)
}
